import { create } from 'zustand';
import { House } from '../types/house';
import { api } from '../api/storageApi';

interface HouseStore {
  houses: House[];
  loading: boolean;
  error: string | null;
  fetchHouses: () => Promise<void>;
  addHouse: (house: House) => Promise<void>;
  updateHouse: (id: string, updates: Partial<House>) => Promise<void>;
  removeHouse: (id: string) => Promise<void>;
  getHouse: (id: string) => House | undefined;
}

export const useHouseStore = create<HouseStore>((set, get) => ({
  houses: [],
  loading: false,
  error: null,
  fetchHouses: async () => {
    set({ loading: true, error: null });
    try {
      const houses = await api.houses.list();
      set({ houses, loading: false });
    } catch (err) {
      set({ error: 'Failed to fetch houses', loading: false });
    }
  },
  addHouse: async (house) => {
    try {
      await api.houses.create(house);
      set((state) => ({ houses: [house, ...state.houses] }));
    } catch (err) {
      console.error(err);
    }
  },
  updateHouse: async (id, updates) => {
    try {
      await api.houses.update(id, updates);
      set((state) => ({
        houses: state.houses.map((h) => (h.id === id ? { ...h, ...updates } : h)),
      }));
    } catch (err) {
      console.error(err);
    }
  },
  removeHouse: async (id) => {
    try {
      await api.houses.delete(id);
      set((state) => ({ houses: state.houses.filter((h) => h.id !== id) }));
    } catch (err) {
      console.error(err);
    }
  },
  getHouse: (id) => get().houses.find((h) => h.id === id),
}));
